<script>
export default {
  data() {
    return {
      query: ""
    };
  },
  props: {
    label: {
      type: String,
      required: true
    },
    selected: {
      type: [Boolean, Object],
      required: false
    },
    results: {
      type: Array,
      required: true
    },
    preloader: {
      type: Boolean,
      required: true
    },
    labels: {
      type: Array,
      required: true
    },
    separators: {
      type: Array,
      required: false,
      default: () => [" "]
    }
  },
  methods: {
    search() {
      this.$emit("search", this.query);
    },
    select(val) {
      this.query = this.getLabel(val);
      this.$emit("select", val);
    },
    clear() {
      this.query = "";
      this.$emit("select", null);
    },

    getLabel(obj) {
      if (obj) {
        var ret = "";

        this.labels.forEach((label, index) => {
          ret += obj[label] + this.separators[index];
        });

        return ret;
      }
    }
  },

  mounted() {
    this.query = this.getLabel(this.selected);
  },

  watch: {
    selected() {
      this.query = this.getLabel(this.selected);
    }
  }
};
</script>

<template>
  <v-container class="ac-container">
    <v-layout justify-center row wrap>
      <v-flex grow>
        <input
          @keyup.enter="search(query)"
          :disabled="this.selected"
          id="search"
          type="text"
          :placeholder="this.label"
          v-model="query"
          autocomplete="off"
          class="with-icon icon-search sm text-lowercase"
        />
      </v-flex>

      <v-flex>
        <v-btn
          v-if="this.selected"
          :loading="preloader"
          small
          class="primary text-lowercase"
          @click="clear()"
        >
          <span>limpar</span>
        </v-btn>

        <v-btn
          v-else
          :loading="preloader"
          small
          class="primary text-lowercase"
          @click="search(query)"
          @keyup.enter="search(query)"
        >
          <span>buscar</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout column>
      <ul v-if="results.length">
        <li
          v-for="(result, index) in results"
          :key="index"
          @click="select(result)"
        >
          {{ getLabel(result) }}
        </li>
      </ul>
    </v-layout>
  </v-container>
</template>

<style scoped>
ul {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 5px;
  border: 1px solid #eee;
  border-radius: 0 0 4px 4px;
}

ul li {
  width: calc(100% - 20px);
  padding: 10px 10px;
  cursor: pointer;
  font-size: 14px;
  background-color: #fff;
}

ul li:hover {
  background-color: #f9f9f9;
}
.ac-container {
  max-width: 500px;
}

.ac-container input {
  width: 100%;
}

.ac-container button {
  width: calc(100% - 16px);
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Autocomplete.vue